import { ReactNode } from 'react';
import { IconType } from 'react-icons/lib';

export enum ROLES {
  WORKER = 'worker',
  MANAGER = 'manager',
  ADMIN = 'admin',
  CHIEF = 'chief',
  TRADE_MARKETING = 'trade-marketing',
}

export type Permissions =
  | {
      roles: Array<ROLES>;
    }
  | {
      all: true;
    };

export type MenuItem = {
  id: string;
  name: string;
  icon: IconType;
  to: string;
  permissions: Permissions;
  counterId?: string;
};

export type MenuCategory = {
  id: string;
  name: string;
  children: Array<MenuItem>;
  permissions: Permissions;
};
